<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="代祭预约"
      fixed
      :z-index="99"
      left-arrow
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->


    <van-tabs
      sticky
      offset-top="46"
      title-active-color="#fff"
      title-inactive-color="#f2f2f2"
      background="#24a378"
      color="#fff"
      :border="false"
    >
    <div v-for="item in typeList" :key="item.id">
      <van-tab :title="item.ProductTypeName">
        <booking_Goods_list_tab :typeid="item.Id" />
      </van-tab>
    </div>



      <!-- <van-tab title="全部">
        <div class="book-goods-section">
          <router-link to="/BookingGoodsDetails" class="book-goods-list" v-for="item in 5" :key="item.id">
            <div class="hd">
              <img src="https://img.yzcdn.cn/vant/cat.jpeg" alt class="avatar" />
            </div>
            <div class="bd">
              <h2 class="title">清明节鲜花祭祀黄白菊</h2>
              <div class="ft">
                <div class="price">
                  ￥
                  <span class="money">119.0</span>
                  <span class="c6">元</span>
                </div>
                <div class="num">2人预约</div>
              </div>
            </div>
          </router-link>
        </div>
      </van-tab>
      <van-tab title="花束">
        <van-divider dashed>暂无</van-divider>
      </van-tab>
      <van-tab title="盆花">
        <van-divider dashed>暂无</van-divider>
      </van-tab>
      <van-tab title="花篮">
        <van-divider dashed>暂无</van-divider>
      </van-tab> -->
    </van-tabs>
  </div>
</template>

<script>
import booking_Goods_list_tab from "@/components/booking/booking_Goods_list_tab"
export default {
  data() {
    return {
      typeList:{},

    };
  },
  components:{
    booking_Goods_list_tab
  },
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    init(){
      var that = this;
      that.$store.dispatch({
        type : "GetProductProductSearchList",
        PageRows : 12,
      }).then(res => {
        console.log(res);
        that.typeList = res.ProductTypeList;
      },err => {})


    }

  },
  created(){
    var that = this;
    that.init();
  }
};
</script>

<style scoped>
.book-goods-section {
  margin: 1.5%;
  overflow: hidden;
}
.book-goods-list {
  display: block;
  background-color: #fff;
  border-radius: 6px;
  width: 47%;
  float: left;
  margin: 1.5%;
}
.book-goods-list > .hd {
  width: 100%;
  height: 0;
  font-size: 0;
  position: relative;
  padding-bottom: 100%;
}
.book-goods-list > .hd > .avatar {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}
.book-goods-list > .bd {
  padding: 10px;
}
.book-goods-list > .bd .title {
  font-size: 15px;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.book-goods-list > .bd .ft {
  display: flex;
  align-items: center;
  margin-top: 4px;
}
.book-goods-list > .bd .ft .price {
  flex: 1;
  overflow: hidden;
  font-size: 12px;
  color: crimson;
}
.book-goods-list > .bd .ft .price .money {
  font-size: 16px;
}
.book-goods-list > .bd .ft .num {
  margin-left: 10px;
  font-size: 12px;
  color: #888;
}
</style>
